export const isDataOutdated = (endTime: number, threshold: number): boolean => {
  const now = Date.now() / 1000;
  return !endTime || now - endTime > threshold;
};
